module.exports = __webpack_public_path__ + "img/25.6cf27dfb.jpg";